
// Action: file_editor create /app/frontend/src/pages/AboutPage.js --file-text "
import React from 'react';
import About from '../components/About';

const AboutPage = () => {
  return (
    <div data-testid="about-page" className="pt-24">
      <About />
    </div>
  );
};

export default AboutPage;

// Observation: Create successful: /app/frontend/src/pages/AboutPage.js